<template>
  <div class="v-text-field__details">
    <div class="v-messages theme--light error--text mb-4" role="alert">
      <div class="v-messages__wrapper">
        <div v-for="(error, index) in errors" :key="index" class="v-messages__message mb-0">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseErrorMessage',
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
